<template>
  <v-list nav
    density="compact"
    ref="nav_list"
    v-model:opened="selectedMenu"
  >
    <!-- <template > -->
      <IStoreSidebarNavRecursive
        v-for="(folder, i) in folder_list"
        :key="'root-' + i"
        :folder="folder"
        :depth="0"
        @goto="goto"
        @toggle-folder="toggleFolder"
      />
    <!-- </template> -->
  </v-list>
  <div id="iframe-container"></div>
  <!-- <iframe id="loginNotify" style="display: none"></iframe> -->
</template>

<script>
import $ from 'jquery'
import istoreSetting from '@/scripts/istore-setting.js'
import iStoreUtils from '@/scripts/istore-utils.js'
import crypto from '@/scripts/crypto.js'
import imanager3Appframe from "@/scripts/imanager3-appframe.js"
import { ref } from 'vue'
import IStoreSidebarNavRecursive from './IStoreSidebarNavRecursive.vue'


export default {
  name: 'IStoreSidebarNav',
  components: {
    IStoreSidebarNavRecursive
  },
  data() {
    return {
      functions: null,
      isPluginNotify: false,
      isReady: false,
      nav_list:ref(null),
      folder_list:null
    }
  },
  created() {
    if (istoreSetting.debug) {
      window.IStoreSidebarNav = this
    }
  },
  mounted() {
    this.init()
    this.pluginNotify()
  },
  methods: {
    init() {
      console.debug("#[IStoreSidebarNav] init")
      const rs = iStoreUtils.buildFolder(this.$store.state.iStoreInterfaceData);
      this.functions = rs.functions
      this.folderIcon = rs.folderIcon
      this.$store.commit('setFunctions', JSON.parse(JSON.stringify(this.functions)))
      this.folder_list = this.$store.state.menuFunctions
      this.checkHasTemp(this.folder_list)
      this.createGroupNav(this.folder_list)
    },
    checkHasTemp(node) {
      if (Array.isArray(node)) {
        // Process each folder in the array
        node.forEach(this.checkHasTemp);
        return node;
      }

      // Check if this folder has any temp functions
      const hasTempInFolder = node.functions?.some(f => f.isTemp) || false;

      // Recursively check child folders
      let hasTempInFunctions = false;
      if (Array.isArray(node.folders)) {
        node.folders.forEach(child => {
          if (this.checkHasTemp(child)) {
            hasTempInFunctions = true;
          }
        });
      }

      // Add flag to current folder
      node.hasTempInTree = hasTempInFolder || hasTempInFunctions;

      return node.hasTempInTree;
    },
    createGroupNav(listFolder){
      for (let index = 0; index < listFolder.length; index++) {
        const theFolders = listFolder[index].folders;
        this.createGroupNav(theFolders)
      }
    },
    pluginNotify() {
      if (this.isPluginNotify) {
        return
      }
      this.isPluginNotify = true;

      // do plugin notify
      try {
        const plugins = this.$store.state.iStoreInterfaceData.filter(t => t.pluginId)

        const result = Object.assign({}, this.$store.state.loginUser)
        delete result.pxd
        delete result.userFunctions

        const pluginSet = new Set()
        for (let p of plugins) {         
          if (p.url) {
            if (!pluginSet.has(p.pluginId)) {
              pluginSet.add(p.pluginId)

              let token = imanager3Appframe._createToken(p.pluginId, 'loginNotify')

              let targetURL = p.url;
              if (!targetURL.startsWith('http')) {
                targetURL = `https://${location.hostname}:${location.port}/${targetURL}`
              }

              let _url = new URL(targetURL);
              if (!(location.host.includes("localhost") || location.host.includes("127.0.0.1"))
                && (_url.host.includes("localhost") || _url.host.includes("127.0.0.1"))) {
                _url.host = location.host
                _url.port = location.port
              }
              _url.hash = "#/loginNotify"
              _url.search = `?token=${token}&loginInfo=${crypto.encrypt(JSON.stringify(result))}&_t=${Date.now()}`
              let _path = _url.toString();

              // document.getElementById("loginNotify").src = _path

              // Create a new iframe element
              const iframe = document.createElement("iframe");
              iframe.style.display = "none";
              iframe.src = _path;
              iframe.id = `loginNotify-${p.pluginId}`;

              // Create a bound message handler for this specific iframe
              let messageHandler;
              messageHandler = (event) => this.handleIframeMessage(event, iframe, messageHandler);

              // Store the message handler on the iframe for cleanup
              iframe.messageHandler = messageHandler;

              // Adding a listener if the iframe is loaded
              iframe.onload = () => {
                console.log('iframe finished loading');

                // Always add the message listener since we can't reliably check cross-origin iframes
                window.addEventListener('message', messageHandler);
                
                console.log('Message listener added for iframe:', iframe.id);
              };

              // Handle iframe load errors
              iframe.onerror = () => {
                console.error('Failed to load iframe');
                iframe.remove();
              };

              // Optional: Add a timeout to prevent hanging iframes
              const timeoutId = setTimeout(() => {
                console.warn('Iframe loading timeout');
                window.removeEventListener('message', messageHandler);
                iframe.remove();
              }, 30000); // 30 second timeout

              // Store timeout ID on iframe for cleanup
              iframe.timeoutId = timeoutId;

              // Append the iframe to the body or a specific container
              document.body.appendChild(iframe);
              
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleIframeMessage(event, iframe, messageHandler) {
      const data = event.data;

      // Basic security check - you should replace '*' in postMessage with actual origin
      // if (event.origin !== 'https://your-expected-domain.com') return;

      if (data && data.type === 'inner-iframe-loaded') {
        console.log('Received message: inner iframe loaded', data);
        
        // Clear the timeout if it exists
        if (iframe.timeoutId) {
          clearTimeout(iframe.timeoutId);
        }

        // Remove the specific event listener for this iframe
        window.removeEventListener('message', messageHandler);
        
        // Remove the iframe
        iframe.remove();
        
        // Handle your payload
        if (data.payload) {
          console.log('Processing payload:', data.payload);
          // Handle your API response here
        }
      }
    },
    goto(func) {
      console.debug('#[IStoreSidebarNav] goto:', JSON.stringify(func, null, 2))
      this.$store.commit('setCurrentMenu', 'loading')
      setTimeout(() => {
        this.$store.commit('setCurrentMenu', func)
        if (func.type !== 'url') {
          // To prevent duplicate on plugin menu click
          this.sendTrackingAction(
            this.$store.state.loginUser.userId,
            "Load Page",
            {
              "page": `${iStoreUtils.toPascalCase(func.name)}`
            }
          )
        }
        if (func.type === 'path') {
          this.$router.replace(func.url)
        } else if (this.$route.path !== '/dashboard') {
          this.$router.replace('/dashboard')
        }
      }, 50)
    },
    toggleFolder(event, folder) {
      // 當前是收合的，所以 < 80，等一下會展開
      folder.opened = $(event.target).parent().height() < 80;
      console.debug("folder:%O", folder)
    },
    isActive(func) {
      if (this.$store.state.currentMenu) {
        return func.parent === this.$store.state.currentMenu.parent
          && func.module === this.$store.state.currentMenu.module
          && func.name === this.$store.state.currentMenu.name
      }
      return false
    },
    async sendTrackingAction(starNumber, action, data){
      await imanager3Appframe.sendTrackingAction({
        starNumber: starNumber,
        pluginName: "main",
        uuid: iStoreUtils.generateTrackingUuid(),
        userAction: action,
        data: data
      })
    }
  },
  watch: {
    '$store.state.iStoreInterfaceDataUpdateTime'() {
      this.init()

      if (this.$store.state.tempOpenFolder) {
        let functions = this.$store.state.tempOpenFolder;
        console.debug("#[openFolder] parentKeys:", functions[0].parentKeys)
        if (functions[0].parentKeys) this.$store.commit("openFolder", {parentKeys:functions[0].parentKeys})
      }
    }
  },
  computed: {
    isOver() {
      return this.$store.state.sidebarOver;
    },
    selectedMenu: {
      get() {
        return this.$store.state.sidebarOpenedFolders
      },
      set(val) {
        this.$store.commit("setSidebarOpenedFolders", val)
      }
    }
  }
}
</script>

<style lang="scss">
.v-list-group{
  --prepend-width:1px !important
}
.v-list-item{
  --prepend-width:20px !important
}
</style>